import { InfoButton, Text, Tooltip, vars } from '@etg/wings';
import { CheckCircle } from '@phosphor-icons/react';
import { CABIN_UPGRADE } from '../../products';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const CabinUpgradeAvailabilityStatus = _ref => {
  let {
    availabilityTexts,
    isSegmentAvailable
  } = _ref;
  const {
    ariaLabelText,
    availabilityCard
  } = availabilityTexts;
  const availabilityStatusText = isSegmentAvailable ? availabilityCard.availableStatus : availabilityCard.unavailableStatus;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isSegmentAvailable ? /*#__PURE__*/_jsx(CheckCircle, {
      "aria-hidden": true,
      color: vars.colors.signal.positive.light,
      "data-testid": `${CABIN_UPGRADE.name}-availability-status-available-icon`,
      size: 24,
      weight: "fill"
    }) : /*#__PURE__*/_jsx(Tooltip, {
      "aria-live": "polite",
      content: /*#__PURE__*/_jsx(Text, {
        children: availabilityCard.statusTooltip
      }),
      "data-testid": `${CABIN_UPGRADE.name}-availability-status-tooltip`,
      title: "tooltip",
      trigger: "click",
      children: /*#__PURE__*/_jsx(InfoButton, {
        "data-testid": `${CABIN_UPGRADE.name}-availability-status-unavailable-icon`,
        label: ariaLabelText
      })
    }), /*#__PURE__*/_jsx(Text, {
      "aria-hidden": true,
      children: availabilityStatusText
    })]
  });
};
export default CabinUpgradeAvailabilityStatus;